import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ActiveBranchCard.module.css';
import Pill from '../common/Pill';
import Ico from '../common/Ico';
import NightlyStreak from '../branches/NightlyStreak';
import { statusLabel } from '../branches/statusConfig';
import { timeSinceTS } from '../../helpers/dates';

const ICO_ROCKET = 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z';

export default function ActiveBranchCard({ branch, latestRelease, nightlyRuns = [] }) {
  const navigate = useNavigate();
  const sortedRuns = [...nightlyRuns].sort((a, b) => a.number - b.number);
  const recentDeploys = [...nightlyRuns]
    .filter((r) => r.rollout_created)
    .sort((a, b) => b.number - a.number)
    .slice(0, 3);
  const goToBranch = () => navigate(`/branches/${branch.version}`);

  return (
    <div
      className={styles.card}
      onClick={goToBranch}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') goToBranch(); }}
    >
      <div className={styles.top}>
        <span className={styles.version}>{branch.version}</span>
        <Pill status={branch.status} dot pulse={branch.status === 'branching'}>
          {statusLabel(branch.status)}
        </Pill>
        {latestRelease && (
          <span className={styles.releasedBadge}>
            <Ico d={ICO_ROCKET} size={10} strokeWidth={2} />
            {latestRelease.version} released {timeSinceTS(latestRelease.release_date)}
          </span>
        )}
      </div>

      <div className={styles.meta}>
        {branch.deploy_target && <span>{branch.deploy_target}</span>}
        {branch.deploy_target && <span className={styles.metaDot}>·</span>}
        <span>branched {timeSinceTS(branch.created)}</span>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionLabel}>Nightly (14d)</div>
        <NightlyStreak runs={sortedRuns} />
      </div>

      {recentDeploys.length > 0 && (
        <div className={`${styles.section} ${styles.sectionBordered}`}>
          <div className={styles.sectionLabel}>Recent deploys</div>
          <div className={styles.buildsList}>
            {recentDeploys.map((r) => (
              <div key={r.id} className={styles.buildRow}>
                <span className={styles.buildTag}>{r.build_tag || r.result?.build_docker?.image_tag || `#${r.number}`}</span>
                <Pill status={r.rollout_status} dot pulse={r.rollout_status === 'deploying'}>{statusLabel(r.rollout_status)}</Pill>
                <span className={styles.buildWhen}>{timeSinceTS(r.triggered_at)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
